module.exports = __webpack_public_path__ + "fonts/Montserrat-600-17.2d3f60b.woff2";